import { apiService } from "../../services/apiServices";
import { ActionTypes } from "../constants/actionTypes";


export const teamsFetch = (authParams, history, handleError) => {
  return (dispatch) => {
    apiService
      .getTeams(authParams)
      .then((response) => {
        const { data } = response;
        dispatch({
          type: ActionTypes.TEAMS_FETCH,
          payload: data,
        });
      })
      .catch(({ response = {} }) => {
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      });
  };
};
